import { Table, Button } from "antd";
import qs from "qs";
import React, { useState, useEffect } from "react";
import { getAssets } from "../Api/ApiCalls";

const MainTable = ({ value, setValues }) => {
  const [data, setData] = useState(null);
  const [currentPage, setCurrentPage] = useState("");
  const query = qs.stringify(
    {
      filters: {
        Serial: {
          $contains: value.Selected === "Serial" ? value.text : null,
        },
        employee: {
          EmployeeId: {
            $contains: value.Selected === "EmployeeId" ? value.text : null,
          },
        },
      },
      populate: "employee",
      pagination: {
        page: currentPage,
        pageSize: 10,
      },
    },
    {
      encodeValuesOnly: true, // prettify URL
    }
  );

  useEffect(() => {
    const fetchData = async () => {
      const data = await getAssets(query);
      setData(data);
    };
    fetchData();
  }, [value, query]);

  if (!data) {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <h2>Loading</h2>
      </div>
    );
  }

  const ApiData = data?.data?.map((data) => {
    const employees = data.attributes.employee?.data?.attributes;

    return { ...data.attributes, ...employees };
  });

  const columns = [
    {
      title: "SERIAL NUMBER",
      dataIndex: "Serial",
      align: "center",
    },

    {
      title: "ITEM",
      dataIndex: "ItemName",
      align: "center",
    },
    {
      title: "SPECIFICATION",
      dataIndex: "Specs",
      with: "150px",
      align: "center",
    },

    {
      title: "BUILDING",
      dataIndex: "Building",
      align: "center",
    },
    {
      title: "FLOOR",
      dataIndex: "Floor",
      align: "center",
    },
    {
      title: "OFFICE",
      dataIndex: "Office",
      align: "center",
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      align: "center",
    },
  ];
  const total = data?.meta.pagination?.total;
  const PageSize = data?.meta.pagination?.pageSize;

  const Name = ApiData[0]?.employee?.data.attributes.Name;
  const Id = ApiData[0]?.employee?.data.attributes.EmployeeId;

  return (
    <div
      style={{
        marginTop: "50px",
        paddingLeft: "50px",
        paddingRight: "50px",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <Button
          onClick={() => setValues("")}
          style={{ borderRadius: "5px", width: "150px" }}
          type="primary"
          htmlType="submit"
          size={"large"}
        >
          الرجوع
        </Button>
      </div>
      {ApiData.length > 0 ? (
        <div style={{ textAlign: "right" }}>
          <h2>الاسم: {Name}</h2>
          <h2>رقم الوظيفي: {Id}</h2>
        </div>
      ) : (
        <div style={{ marginTop: "50px", textAlign: "center" }}>
          <h1>لا يوجد بيانات</h1>
        </div>
      )}
      <Table
        rowClassName={() => "editable-row"}
        bordered
        pagination={{
          total: total,
          PageSize: PageSize,
          onChange: (page) => {
            setCurrentPage(page);
          },
        }}
        dataSource={ApiData}
        columns={columns}
      />
    </div>
  );
};
export default MainTable;
